import { useRecoilValue } from 'recoil';

import { Cards } from 'Components/Cards';
import { Product } from 'Components/Product';
import { filteredProductsState } from 'lib/recoil/selectors';

export const Products = () => {
	const { products } = useRecoilValue(filteredProductsState);

	return (
		<Cards>
			{products.map(product => (
				<Product key={product.name} product={product} />
			))}
		</Cards>
	);
};
